import { useRequestHeaders } from '#imports'

import { E2E_USER_AGENT } from '../constants/e2e-user-agent'
/**
 * Retrieve whether the current environment is the end-to-end testing environment based on the user agent.
 *
 * @example
 * const isE2ETestingEnvironment = useIsE2ETestingEnvironment()
 */
export function useIsE2ETestingEnvironment() {
  const headers = useRequestHeaders()

  if (headers['user-agent']) {
    return headers['user-agent'] === E2E_USER_AGENT
  }

  return window?.navigator?.userAgent === E2E_USER_AGENT
}
